exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-2{\n   margin: 2rem;\n}\n.delog-h2{\n  font-weight: bold;\n  color: #5DAF34;\n}\nspan.sacss {\n    margin-left: 2rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-56d3ef9c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/view/mall/trade/finddrug.vue
// module id = 1488
// module chunks = 0